import {
  LOADING_FRONT_IMAGE,
  FRONT_IMAGE_FAILED,
  FRONT_IMAGE_SUCCESS,
  RESET_FRONT_IMAGE,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_FRONT_IMAGE:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        status: "",
      };

    case FRONT_IMAGE_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        status: "",
      };

    case FRONT_IMAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        status: "",
        data: action.payload,
      };

    case RESET_FRONT_IMAGE:
      return (state = initialState);

    default:
      return state;
  }
};
